import { useCountdown } from './useCountdown';
import { useTranslation } from 'react-i18next';
import GButton from '../../components/ui/base/GButton';

const prizeImages: Record<string, string> = {
    CAR: require('../../assets/images/car.png'),
    IPHONE: require('../../assets/images/iphone.png'),
    PHONE: require('../../assets/images/iphone.png'),
    USD: require('../../assets/images/tether-usdt-logo.png'),
    BITCOIN: require('../../assets/images/bitcoin-btc-logo.png'),
};

interface RaffleCardProps {
    ticket: any;
    period: string;
    onClick: () => void;
}

const periodStyles: Record<string, { gradient: string; accent: string }> = {
    daily: { gradient: 'from-[#0a1628] via-[#0d2a52] to-[#1a3a6a]', accent: '#4DBDFF' },
    weekly: { gradient: 'from-[#0a1628] via-[#1a2a15] to-[#2a5741]', accent: '#4DFF8F' },
    monthly: { gradient: 'from-[#1a1020] via-[#2a1525] to-[#5e2627]', accent: '#FF9F4D' },
};

const RaffleCard = ({ ticket, period, onClick }: RaffleCardProps) => {
    const { t } = useTranslation();
    const style = periodStyles[period.toLowerCase()] || periodStyles.daily;
    const { days, hours, minutes, seconds } = useCountdown(ticket.expiresAt);

    

    const meta = ticket.meta ? (typeof ticket.meta === 'string' ? JSON.parse(ticket.meta) : ticket.meta) : {};
    const price = meta.ticketPrice ?? meta.price ?? 0;
    const isFree = meta.isFree === true || price === 0;
    const prizeImage = meta.prizeType ? prizeImages[meta.prizeType.toUpperCase()] : null;
    console.log({meta: meta.prizeType});

    return (
        <button
            onClick={onClick}
            className={`group relative w-full rounded-[16px] overflow-hidden bg-gradient-to-r ${style.gradient} border border-white/[0.08] transition-all duration-300 hover:border-white/[0.15] hover:shadow-[0_4px_30px_rgba(0,0,0,0.3)] hover:scale-[1.005] text-left`}
        >
            <div className="flex flex-col md:flex-row items-center">
                {/* Prize Image */}
                {prizeImage && (
                    <div className="flex-shrink-0 p-[16px] md:p-[20px] flex items-center justify-center">
                        <img src={prizeImage} alt={meta.prizeType} className="w-[100px] h-[80px] md:w-[140px] md:h-[100px] object-contain transition-transform duration-500 group-hover:scale-105" />
                    </div>
                )}
                {/* Ticket Info */}
                <div className="flex-1 p-[20px] md:p-[24px]">
                    <h3 className="text-[20px] md:text-[24px] font-bold text-white mb-[4px]">{ticket.name}</h3>
                    <p className="text-white/40 text-[13px] font-medium mb-[12px]">{period} {t('raffle.draw')}</p>
                    <div className="inline-flex items-center gap-[6px] px-[12px] py-[6px] rounded-[8px] bg-white/[0.06] border border-white/[0.08]">
                        <span className="text-[12px] font-semibold" style={{ color: style.accent }}>
                            {isFree ? t('raffle.freeTicketAvailable') : t('raffle.buyTickets')}
                        </span>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={style.accent} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="transition-transform duration-200 group-hover:translate-x-[3px]">
                            <path d="M5 12h14M12 5l7 7-7 7" />
                        </svg>
                    </div>
                </div>

                {/* Right - Countdown Timer */}
                <div className="flex-shrink-0 p-[20px] md:p-[24px] flex flex-col items-center md:min-w-[220px]">
                    <div className="flex items-center gap-[6px] text-white/50 text-[13px] font-semibold mb-[8px]">
                        <span>{t('raffle.timeRemaining')}</span>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="12" cy="12" r="10" /><path d="M12 6v6l4 2" />
                        </svg>
                    </div>
                    <p className="text-white/30 text-[12px] mb-[10px]">Draw #{ticket.code?.slice(-3) || '001'}</p>
                    <div className="flex gap-[6px]">
                        {[
                            { value: days, label: t('raffle.days') },
                            { value: hours, label: t('raffle.hours') },
                            { value: minutes, label: t('raffle.min') },
                            { value: seconds, label: t('raffle.sec') },
                        ].map((item) => (
                            <div key={item.label} className="flex flex-col items-center">
                                <div className="w-[44px] h-[44px] rounded-[10px] bg-white/[0.08] border border-white/[0.1] flex items-center justify-center" style={{ color: style.accent }}>
                                    <span className="text-[18px] font-bold">{String(item.value).padStart(2, '0')}</span>
                                </div>
                                <span className="text-white/30 text-[9px] mt-[4px] font-medium">{item.label}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </button>
    );
};

export default RaffleCard;
